module.exports = __webpack_public_path__ + "img/captcha.2dd208d5.png";